import { useMutation } from '@tanstack/react-query'
import { userApi } from '../../utils/api'
import { useAuth } from '../../contexts/AuthContext'

/**
 * プロフィール（表示名）更新（ProfilePage）。
 * 成功時に AuthContext を再取得して user を即時反映する
 * （user は Query ではなく AuthContext が真実源のため、invalidateQueries ではなく refreshUser で整合）。
 */
export function useUpdateProfile() {
  const { refreshUser } = useAuth()
  return useMutation({
    mutationFn: (displayName: string) => userApi.updateProfile(displayName),
    onSuccess: () => refreshUser(),
  })
}
